import { CircularProgress, Grid2, Typography } from "@mui/material";
import Container from "../../../components/Container";
import ProfileSettings from "../../../components/Screens/ProfileSettings";
import { useAuth } from "../../../hooks/useAuth";
import { useApp } from "../../../contexts/AppContext";

export default function SystemProfile() {
    const { translate } = useApp()
    const { user } = useAuth()

    if (!user) return <CircularProgress />

    return (
        <Grid2 container size={'grow'} spacing={2}>

            <Grid2 container size={'grow'} flexDirection={'column'} spacing={2}>

                <Container container size={'auto'} paddingX={4} paddingY={2} justifyContent={'space-between'} alignItems={'center'}>
                    <Grid2>
                        <Typography variant='h4' fontWeight={'bold'} color='primary'>
                            {translate("Profile Settings")}
                        </Typography>
                    </Grid2>
                </Container>

                <Container container flexDirection={'column'} spacing={2} padding={4}>
                    <ProfileSettings />
                </Container>

            </Grid2>

        </Grid2>
    )
}